export const OUTBOUND_VISA = [
  {
    country: "🇺🇸 สหรัฐอเมริกา (USA)",
    types: ["B1/B2 (Tourist/Business)", "F1 (Student)", "J1 (Exchange)", "K1 (Fiancé)", "K3 (Spouse)", "IR/CR (Marriage GC)", "H1B (Work)", "L1 (Intra-company)", "O1 (Extraordinary)", "EB-5 (Investor)", "ESTA"],
  },
  {
    country: "🇬🇧 สหราชอาณาจักร (UK)",
    types: ["Standard Visitor", "Student (Tier 4)", "Spouse / Partner", "Fiancé(e)", "Skilled Worker", "Health & Care Worker", "Global Talent", "Investor", "Ancestry"],
  },
  {
    country: "🇪🇺 Schengen (27 ประเทศ)",
    types: ["Schengen Tourist (Type C)", "Business Visa", "Student Visa", "Family Reunification", "National Visa (Type D)", "EU Blue Card", "Job Seeker (DE)", "Au Pair (FR/DE)"],
  },
  {
    country: "🇦🇺 ออสเตรเลีย",
    types: ["Visitor (600)", "Student (500)", "Skilled Independent (189)", "Skilled Nominated (190)", "TSS (482)", "Partner (820/801)", "Prospective Marriage (300)", "Working Holiday (417)", "PR pathway"],
  },
  {
    country: "🇨🇦 แคนาดา",
    types: ["Visitor (TRV)", "Study Permit", "Work Permit", "Express Entry (FSW)", "Provincial Nominee (PNP)", "Spousal Sponsorship", "Start-up Visa", "Super Visa"],
  },
  {
    country: "🇳🇿 นิวซีแลนด์",
    types: ["Visitor Visa", "Student Visa", "Essential Skills Work", "Skilled Migrant", "Partner Visa", "Working Holiday"],
  },
  {
    country: "🇯🇵 ญี่ปุ่น",
    types: ["Tourist", "Student", "Work (Engineer/Specialist)", "Spouse of Japanese", "Highly Skilled Professional", "Specified Skilled Worker"],
  },
  {
    country: "🇰🇷 เกาหลีใต้",
    types: ["C-3 (Tourist)", "D-2 (Student)", "D-4 (Language)", "E-2 (Teaching)", "E-7 (Work)", "F-6 (Spouse)", "K-ETA"],
  },
  {
    country: "🇨🇳 จีน",
    types: ["L (Tourist)", "M (Business)", "F (Exchange)", "X1/X2 (Student)", "Z (Work)", "Q1/Q2 (Family)", "Transit"],
  },
  {
    country: "อื่นๆ ทั่วโลก",
    types: ["UAE / Dubai", "Saudi Arabia", "Israel", "India", "Brazil", "Russia", "South Africa", "Egypt", "Singapore (LTVP/PR)", "Taiwan", "Hong Kong"],
  },
] as const;

export const INBOUND_THAI_VISA = [
  {
    group: "ท่องเที่ยว & พำนักระยะสั้น",
    types: ["Tourist Visa (TR-60)", "Tourist Multiple Entry (METV)", "Visa Exempt", "Transit Visa", "Visa on Arrival (VOA)"],
  },
  {
    group: "การศึกษา & ฝึกอบรม",
    types: ["Non-Immigrant ED (Student)", "Non-Immigrant ED (Training)", "Non-Immigrant ED (Internship)", "Non-Immigrant ED (Monk/Religious)"],
  },
  {
    group: "ทำงาน & ธุรกิจ",
    types: ["Non-Immigrant B (Business/Work)", "Non-Immigrant B-A (Investment)", "Non-Immigrant IB (BOI Promoted)", "Non-Immigrant M (Media)", "SMART Visa (T/I/E/S/O 5 ประเภท)", "Work Permit (WP.3, WP.10, WP.11)"],
  },
  {
    group: "ครอบครัว & พำนักระยะยาว",
    types: ["Non-Immigrant O (Marriage)", "Non-Immigrant O (Dependent)", "Non-Immigrant O-A (Retirement 50+)", "Non-Immigrant O-X (Retirement 10 ปี)", "Permanent Residence (PR)"],
  },
  {
    group: "Long-term & Premium",
    types: ["LTR Wealthy Global Citizen", "LTR Wealthy Pensioner", "LTR Work-from-Thailand Pro", "LTR Highly Skilled Pro", "DTV (Destination Thailand Visa)", "Thailand Privilege (Elite Visa)", "APEC Business Travel Card"],
  },
] as const;
